import { render, staticRenderFns } from "./DeleteCell.vue?vue&type=template&id=24a835b0&scoped=true&"
import script from "./DeleteCell.vue?vue&type=script&lang=babel&"
export * from "./DeleteCell.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a835b0",
  null
  
)

export default component.exports